// Government schemes catalogue — ported from
// agrosense-main/app/lib/screens/schemes/schemes_screen.dart
// (kept fully offline; no network required to render this tab).

export const SCHEMES = [
  {
    id: 'pmkisan',
    name: 'PM-KISAN',
    emoji: '💰',
    category: 'Income Support',
    description: 'Direct income support of ₹6,000/year to all landholding farmer families in three equal instalments.',
    benefit: '₹6,000/year (₹2,000 × 3 instalments directly to bank account)',
    eligibility: 'All landholding farmer families with cultivable land. Excludes institutional landholders, government employees, income tax payers.',
    howToApply: '1. Visit nearest CSC (Common Service Centre)\n2. Or apply online at pmkisan.gov.in\n3. Documents: Aadhaar, land records, bank passbook',
    deadline: 'No deadline — ongoing scheme',
    url: 'https://pmkisan.gov.in',
    states: [],
      acronyms: ['PMKISAN', 'PM-KISAN'],
  },
  {
    id: 'pmfby',
    name: 'PM Fasal Bima Yojana',
    emoji: '🛡️',
    category: 'Crop Insurance',
    description: 'Comprehensive crop insurance covering pre-sowing to post-harvest losses due to natural calamities, pests and diseases.',
    benefit: 'Full sum insured. Premium: 2% for Kharif, 1.5% for Rabi, 5% for commercial crops',
    eligibility: 'All farmers growing notified crops in notified areas. Compulsory for loanee farmers, voluntary for others.',
    howToApply: '1. Apply through bank/CSC before sowing cutoff\n2. Or at insurance company offices\n3. Documents: land records, Aadhaar, bank details, sowing certificate',
    deadline: 'Kharif: July 31 | Rabi: December 31 (varies by state)',
    url: 'https://pmfby.gov.in',
    states: [],
      acronyms: ['PMFBY', 'PMFBY-2020'],
  },
  {
    id: 'pkvy',
    name: 'Paramparagat Krishi Vikas (PKVY)',
    emoji: '🌿',
    category: 'Organic Farming',
    description: 'Promotes organic farming by providing financial assistance for organic inputs, certification and marketing.',
    benefit: '₹50,000/acre over 3 years (₹31,000 for organic inputs, ₹8,800 for certification, remaining for marketing)',
    eligibility: 'Farmers willing to convert to organic farming. Applied in clusters of 20+ farmers covering 20+ acres.',
    howToApply: '1. Form a group of 20+ farmers\n2. Approach nearest KVK or agriculture department\n3. Apply through state agriculture department',
    deadline: 'Ongoing — apply before Kharif season',
    url: 'https://pgsindia-ncof.gov.in',
    states: [],
      acronyms: ['PKVY', 'Paramparagat'],
  },
  {
    id: 'pmksy',
    name: 'PM Krishi Sinchai Yojana',
    emoji: '💧',
    category: 'Irrigation',
    description: 'Har Khet Ko Pani — provides irrigation to every farm. Subsidises drip and sprinkler systems under Per Drop More Crop component.',
    benefit: '55% subsidy for small/marginal farmers, 45% for others on drip/sprinkler systems',
    eligibility: 'All farmers. Small/marginal farmers get higher subsidy. Priority to SC/ST farmers.',
    howToApply: '1. Register at pmksy.gov.in or state portal\n2. Apply through district agriculture office\n3. Documents: land records, Aadhaar, bank account',
    deadline: 'Ongoing — apply before season',
    url: 'https://pmksy.gov.in',
    states: [],
      acronyms: ['PMKSY', 'Har Khet Ko Pani', 'Per Drop More Crop'],
  },
  {
    id: 'msp',
    name: 'Minimum Support Price (MSP)',
    emoji: '💹',
    category: 'Price Support',
    description: 'Government-assured minimum price for notified crops. Farmers can sell to government procurement centres (mandis) at MSP if market price falls below.',
    benefit: 'MSP 2024-25: Rice ₹2300, Wheat ₹2275, Maize ₹2090, Cotton ₹7121, Groundnut ₹6783/quintal',
    eligibility: 'All farmers growing notified crops during procurement season.',
    howToApply: '1. Register at your state\'s procurement portal\n2. Bring produce to nearest procurement centre/mandi\n3. Documents: land records, Aadhaar, bank passbook',
    deadline: 'Procurement season: Kharif Nov–Feb | Rabi Apr–Jun',
    url: 'https://farmer.gov.in',
    states: [],
      acronyms: ['MSP', 'Minimum Support Price'],
  },
  {
    id: 'kcc',
    name: 'Kisan Credit Card (KCC)',
    emoji: '💳',
    category: 'Credit & Loans',
    description: 'Flexible revolving credit for crop production, post-harvest expenses, maintenance of farm assets, and allied activities.',
    benefit: 'Credit limit based on land holding. Interest rate 7% p.a. (4% after interest subvention of 3%). No collateral up to ₹1.6 lakh.',
    eligibility: 'All farmers — owner cultivators, tenant farmers, sharecroppers. Allied activities (fishermen, animal husbandry) also eligible.',
    howToApply: '1. Visit nearest bank (any commercial, cooperative, RRB)\n2. Fill KCC application form\n3. Documents: land records, Aadhaar, photograph, ID proof',
    deadline: 'No deadline — apply anytime',
    url: 'https://www.nabard.org/content1.aspx?id=572',
    states: [],
      acronyms: ['KCC', 'Kisan Credit'],
  },
  {
    id: 'soil_health',
    name: 'Soil Health Card',
    emoji: '🧪',
    category: 'Soil & Inputs',
    description: 'Free soil testing and Soil Health Card with nutrient status and fertilizer recommendations for your specific land.',
    benefit: 'Free soil testing every 2 years. Personalised fertilizer recommendation reduces input cost by 10–20%.',
    eligibility: 'All farmers. Priority to small and marginal farmers.',
    howToApply: '1. Contact nearest Soil Testing Lab / agriculture department\n2. Or apply at soilhealth.dac.gov.in\n3. Collect soil sample (6 inch depth) from 5 spots in field',
    deadline: 'Ongoing — available throughout year',
    url: 'https://soilhealth.dac.gov.in',
    states: [],
      acronyms: ['SHC', 'Soil Health Card'],
  },
  {
    id: 'nfsm',
    name: 'National Food Security Mission',
    emoji: '🌾',
    category: 'Seed & Input Subsidy',
    description: 'Provides subsidised seeds of HYV/hybrid varieties, demonstrations, farm machinery, and training for rice, wheat, pulses, coarse cereals and oilseeds.',
    benefit: 'Subsidised seeds (50% subsidy), farm machinery (50%), micronutrient kits, IPM demonstrations',
    eligibility: 'Farmers in identified districts. Priority to small/marginal farmers.',
    howToApply: '1. Contact nearest Block/District Agriculture Office\n2. Or nearest KVK (Krishi Vigyan Kendra)\n3. Apply during seed distribution camps',
    deadline: 'Before season sowing — contact local agriculture office',
    url: 'https://nfsm.gov.in',
    states: [],
      acronyms: ['NFSM'],
  },
  {
    id: 'agri_infra',
    name: 'Agriculture Infrastructure Fund',
    emoji: '🏗️',
    category: 'Infrastructure',
    description: 'Low-interest loans for post-harvest management and agri-logistics infrastructure like warehouses, cold storage, processing units.',
    benefit: '3% interest subvention on loans up to ₹2 crore. Credit guarantee for loans up to ₹2 crore.',
    eligibility: 'Farmers, FPOs, PACS, self-help groups, agri-entrepreneurs, state agencies.',
    howToApply: '1. Apply online at agriinfra.dac.gov.in\n2. Or through banks participating in the scheme\n3. Business plan and DPR required for large loans',
    deadline: 'Ongoing — scheme till 2032',
    url: 'https://agriinfra.dac.gov.in',
    states: [],
      acronyms: ['AIF', 'Agri Infra Fund'],
  },
  {
    id: 'fpo',
    name: 'FPO Formation Scheme',
    emoji: '🤝',
    category: 'Farmer Collective',
    description: '10,000 new FPOs (Farmer Producer Organisations) being formed with financial support of ₹18 lakh each over 5 years.',
    benefit: '₹18 lakh per FPO over 5 years. Equity grant up to ₹15 lakh. Credit guarantee up to ₹2 crore.',
    eligibility: 'Minimum 300 farmers (100 in hilly/tribal areas) willing to form an FPO.',
    howToApply: '1. Form a group of 300+ farmers\n2. Contact NABARD, SFAC or NCDC\n3. Register as FPO with ROC',
    deadline: 'Ongoing — scheme till 2027-28',
    url: 'https://sfacindia.com/fpo.aspx',
    states: [],
      acronyms: ['FPO'],
  },
  {
    id: 'rythubandhu',
    name: 'Rythu Bandhu (Telangana)',
    emoji: '💚',
    category: 'Income Support',
    description: 'Telangana state scheme providing investment support to farmers for each cropping season.',
    benefit: '₹5,000/acre per season (Kharif + Rabi = ₹10,000/acre/year)',
    eligibility: 'All landholding farmers in Telangana. Per acre payment regardless of crop.',
    howToApply: '1. Register at meebhoomi.telangana.gov.in\n2. Link Aadhaar to land records\n3. Bank account in farmer\'s name required',
    deadline: 'Before each season — check local agriculture office',
    url: 'https://rhythubandhu.telangana.gov.in',
    states: ['Telangana'],
      acronyms: ['Rythu', 'RB'],
  },
  {
    id: 'ysrrc',
    name: 'YSR Rythu Bharosa (Andhra Pradesh)',
    emoji: '💙',
    category: 'Income Support',
    description: 'AP state scheme providing investment support for farming families.',
    benefit: '₹13,500/year per farming family (combined with PM-KISAN)',
    eligibility: 'All farmer families in Andhra Pradesh with cultivable land.',
    howToApply: '1. Register at spap.ap.gov.in\n2. Link Aadhaar and land records\n3. Verify at nearest village secretariat',
    deadline: 'Ongoing — apply through village secretariat',
    url: 'https://spap.ap.gov.in',
    states: ['Andhra Pradesh'],
      acronyms: ['YSR', 'YSRRC'],
  },
  {
    id: 'karnataka_raita',
    name: 'Karnataka Raita Siri',
    emoji: '💜',
    category: 'Income Support',
    description: 'Karnataka state scheme providing financial assistance to farmers.',
    benefit: '₹2,000/acre (max 2 acres) per year',
    eligibility: 'Small and marginal farmers in Karnataka owning land up to 2 acres.',
    howToApply: '1. Apply at nearest Nadakacheri / Atalji Janasnehi Kendra\n2. Documents: land records, Aadhaar, bank account',
    deadline: 'Before Kharif season — contact local agriculture office',
    url: 'https://raitamitra.karnataka.gov.in',
    states: ['Karnataka'],
      acronyms: ['Raita Siri'],
  },
];

export const SCHEME_CATEGORIES = [
  'All', 'Income Support', 'Crop Insurance', 'Irrigation', 'Credit & Loans',
  'Seed & Input Subsidy', 'Soil & Inputs', 'Organic Farming', 'Price Support',
  'Infrastructure', 'Farmer Collective',
];

export const INDIAN_STATES = [
  'All India', 'Andhra Pradesh', 'Karnataka', 'Telangana', 'Tamil Nadu',
  'Maharashtra', 'Punjab', 'Haryana', 'Uttar Pradesh', 'Madhya Pradesh',
  'Rajasthan', 'Gujarat', 'West Bengal', 'Bihar', 'Odisha',
];
